import { IMenuBase } from "@/interfaces/IMenu";
import { cn } from "@/lib/utils";

type ButtonSocialProps = Pick<IMenuBase, "icon" | "id" | "label"> & {
  className?: string;
};

const ButtonSocial = (props: ButtonSocialProps) => {
  return (
    <div
      className={cn(
        "grid w-[40px] h-[40px] rounded-full justify-center items-center shadow-03",
        props.className,
      )}
    >
      {props.icon}
    </div>
  );
};

export default ButtonSocial;
